import { render, staticRenderFns } from "./AddressData.vue?vue&type=template&id=5b7ce8c6&"
import script from "./AddressData.vue?vue&type=script&lang=js&"
export * from "./AddressData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports